import styled, { css } from 'styled-components';
import { media } from '@peloton/styles/breakpoints';
import { slate3, white, backgroundGray, gray1 } from '@engage/colors/base';
import { divider1 } from '@engage/colors/tints';
import { spaces } from '@engage/styles/spaces';
import { header6Large, header5Large } from '@engage/typography/headers';

export const Title = styled.h1`
  ${header6Large}
  color: ${slate3};
  margin: 50px auto ${spaces.xLarge}px auto;

  ${media.tablet`
    ${header5Large}
    margin: ${spaces.large}px auto;
  `}
`;

export const Divider = styled.div`
  display: none;

  ${media.tablet`
    border-bottom: 1px solid ${divider1};
    display: block;
    width: 100%;
  `}
`;

export const cardStyles = css`
  background-color: ${white};
  border-radius: 5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.05);
  margin: 0 10px;
`;

export const backgroundStyles = css`
  align-items: center;
  background-color: ${backgroundGray};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  ${media.tablet`
    background-color: ${gray1};
  `}
`;
